export function getCookie(name) { //获取cookie
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	if(arr = document.cookie.match(reg)) {
		var data = unescape(arr[2]);
		return data;
	} else {
		return '';
	}
}
export function delCookie(name) { //删除cookie
	var exp = new Date();
	exp.setTime(exp.getTime() - 1);
	var cval = this.getCookie(name);
	console.log(this.getCookie(name))
	document.cookie = name + "=" + cval + ";path=/;domain=reflower.com.cn;expires=" + exp.toGMTString() + "";
}


// WEBPACK FOOTER //
// ./src/utils/cookie.js